module.exports = __webpack_public_path__ + "static/combined_mockup-cec421a8313479fe7ea6db452b8313c4.png";